"use client";

import { Dialog, DialogDismiss, DialogHeading } from "@ariakit/react";
import { faClose } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import { SITE_NAME } from "@shared/constants";

export default function AdvertiserDisclosure() {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);

  // wait for page to load before querying target element
  useEffect(() => {
    let $target: HTMLElement | null = null;

    if (
      ($target = document.querySelector("#site-header .site-header__container"))
    ) {
      setTarget($target);
    }
  }, []);

  return (
    target &&
    createPortal(
      <>
        <button
          className="text-xs text-neutral-400 underline"
          onClick={() => setOpen(true)}
        >
          Advertiser Disclosure
        </button>
        <Dialog
          open={open}
          className={String(
            typeof document === "undefined"
              ? ""
              : document.querySelector(".page")?.getAttribute("class"),
          )}
        >
          <div className="dialog">
            <div className="dialog__body">
              <DialogHeading className="dialog__title">
                Advertiser Disclosure
              </DialogHeading>
              <div className="dialog__content">
                The offers that appear are from companies which {SITE_NAME}, and
                its partners receive compensation. This compensation may
                influence the selection, appearance, and order of appearance of
                the offers listed below. However, this compensation also
                facilitates the provision by {SITE_NAME} of certain services to
                you at no charge. The offers shown below do not include all
                Financial Services companies or all of their available product
                and service offerings.
              </div>
              <DialogDismiss
                className="button button--is-outlined"
                onClick={() => setOpen(false)}
              >
                <span className="button__content">
                  <span className="button__text">Close</span>
                </span>
              </DialogDismiss>
              <DialogDismiss className="dialog__close">
                <FontAwesomeIcon
                  icon={faClose}
                  onClick={() => setOpen(false)}
                />
                <div className="sr-only">Close info dialog</div>
              </DialogDismiss>
            </div>
          </div>
        </Dialog>
      </>,
      target as HTMLElement,
    )
  );
}
